// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let  CancelOrderMessage = function (fieldSet)
{
    this.Code = Message.CODE_CANCEL_ORDER_MESSAGE
    PFixMessage.call(this, fieldSet)
}

CancelOrderMessage.prototype = Object.create(PFixMessage.prototype)

CancelOrderMessage.prototype.getOrderId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ORDER_ID)
}

CancelOrderMessage.prototype.setOrderId = function (orderId)
{
    this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId)
}

CancelOrderMessage.prototype.getOnBehalfId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID)
}

CancelOrderMessage.prototype.setOnBehalfId = function (onBehalfId)
{
    this.setFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID, onBehalfId)
}

CancelOrderMessage.prototype.getAccountId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ACCOUNT_ID)
}

CancelOrderMessage.prototype.setAccountId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, id)
}

CancelOrderMessage.prototype.getInstrumentId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID)
}

CancelOrderMessage.prototype.setInstrumentId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, id)
}

CancelOrderMessage.prototype.getInstrumentTradableID = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID)
}

CancelOrderMessage.prototype.setInstrumentTradableID = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id)
}

CancelOrderMessage.prototype.setIsBrokerRequest = function (broker)
{
    this.setFieldValue(FieldsFactory.FIELD_IS_BY_BROKER, broker)
}

CancelOrderMessage.prototype.setPlacedFrom = function (placedFrom)
{
    this.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL_ID, placedFrom)
}